// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290034/js/" + chunkId + "." + {"44":"8ec81c21","225":"b8875ebd","481":"d69737cf","486":"db5819f4","770":"113023c4"}[chunkId] + ".0.6464740895684836.chunk.js";
};